<script>
export default {
  computed: {
    url() {
      return (
        process.env.VUE_APP_IMG_CDN +
        ((this.$store.state.appConfig.landing_config || {}).configValue || {})
          .project_path +
        "/"
      );
    },
    swiperImg_list() {
      return (
        (this.$store.state.appConfig.landing_config || {}).configValue || {}
      ).swiperImg_list;
    },
  },
};
</script>
